import {Component, OnInit, Input, Inject, inject, DestroyRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { FabricService } from 'src/app/services/fabric/fabric.service';
import { catchError, tap } from 'rxjs';
import { ClipboardService } from 'ngx-clipboard';
import { ActivatedRoute } from '@angular/router';
import { JumpboxService } from 'src/app/services/api/jumpbox.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { UpperCasePipe } from '@angular/common';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.JUMPBOX_CREATE_PII,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_CREATE_LIVE,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.JUMPBOX_PII,
    name: Feature.JUMPBOX,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.JUMPBOX_LIVE,
    name: Feature.JUMPBOX,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];

@Component({
    selector: 'app-tenant-jumpbox-popup',
    templateUrl: './tenant-jumpbox-popup.component.html',
    styleUrls: ['./tenant-jumpbox-popup.component.scss'],
    standalone: false
})



export class TenantJumpboxPopupComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() tenantId: string;
  @Input() jumpboxData: any;
  tenant: string;
  Constants = Constants;
  usernameData: any;
  passwordData= '';
  copy: boolean;
  datazones: any;
  selectedDatazone: any;
  piiJumboxData: any;
  prodJumboxData: any;
  permissionsMap: { [key: string]: boolean };
  PermissionKeys = PermissionKeys;
  subscriptionIdProd: boolean;
  subscriptionIdPii: boolean;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };

  constructor(private fb: FormBuilder, private clipboardApi: ClipboardService, public activatedRoute: ActivatedRoute, public sidenavService: SidenavService, private dialog: MatDialog, public fabricService:FabricService,
    public jumpboxService: JumpboxService, public toastrService: CustomToastrService, private permissionsService: PermissionsService,  private tenantService: TenantService, private featurePermissionsService: FeaturePermissionsService
  ) {
    
  }

  ngOnInit(): void { 
    this.tenantService.getTenantAccountDetails(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        data?.forEach(item => {
              if(item?.azureDetails) {
                if(item?.dataZone === SubscriptionTypes.PII) {
                  this.subscriptionIdProd = true;
                } else if(item?.dataZone === SubscriptionTypes.NONPII){
                  this.subscriptionIdPii = true;
                }
              }
            })
      });
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.datazones = [
      {
        title: 'pii',
        value: 'PII',
        selected: false,
        bgcolor: 'blue'
      },
      {
        title: 'prod',
        value: 'Prod',
        selected: false,
        bgcolor: 'green'
      },
    ];
    this.fabricService.invokeOperation<any>('mgmt-application-resources', 'get_userinfo')
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
      const extractedUsername = response.attributes.email.split("@")[0];
      this.usernameData = extractedUsername.length > 20 ? extractedUsername.substring(0, 20) : extractedUsername;
      })
     this.piiJumboxData = this.jumpboxData?.filter(item => item.dataZone === 'pii' && (item.status === 'completed' || item.status === 'inprogress'));
     this.prodJumboxData = this.jumpboxData?.filter(item => item.dataZone === 'prod' && (item.status === 'completed' || item.status === 'inprogress'));
    }

  generate(): void {
    const characters = "ABCDEFGHIJKLMNOPWRSTUVWXYZ0123456789!@#$%&abcdefghijklmnopqrstuvwxyz";
    const dictionary = [].concat(characters.split(''));
    let newPassword = '';
    const passwordLength = 16;
    for (let i = 0; i < passwordLength; i++) {
      const index = Math.floor(Math.random() * dictionary.length);
      newPassword = newPassword + dictionary[index];
    }
    const alphanumericRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{16,}$/;
    if( alphanumericRegex.test(newPassword) ){
    this.passwordData = newPassword;
    } else {
      this.generate();
    }
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }
  
  jumpboxConfirm(): void {
    const encryptPassword = btoa(this.passwordData);
    if((this.selectedDatazone === 'pii' && this.piiJumboxData?.length > 2) || (this.selectedDatazone === 'prod' && this.prodJumboxData?.length > 2)) {
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '226px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          newDescription: translate('JUMPBOX.NOT_MORE_THAN_THREE') + (this.selectedDatazone.toUpperCase()) + translate('JUMPBOX.DATAZONE')
        }
      });
    } else {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('JUMPBOX.CREATE_NEW'),
        message: translate('JUMPBOX.CONFIRM_JUMPBOX'),
        confirmButtonText: translate('DIALOG.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const requestObj = {
            tenantId: this.tenantId,
            dataZone: this.selectedDatazone,
            userName: this.usernameData,
            password: encryptPassword,
            expiry: {
              "unit": "days",
              "value": "2"
            },
            size: {
              "cpu": 2,
              "memory": "8GiB"
            }
          }
          this.jumpboxService.createJumpboxes(requestObj)
          .pipe().subscribe((response: any) => {
            if(response) {
              this.sidenavService.closeRightSidenav('true');
            }
          },
            (error) => {
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('JUMPBOX.JUMPBOX_CREATION_FAILED'),
                  description: errorMessage
                }
              });
          });
        }
      })
    }
  }

  optionChange(zone): void {
    this.datazones.filter(item => {
      if(item.title === zone.title) {
        item.selected = true;
        this.selectedDatazone = item.title;
      } else {
        item.selected = false;
      }
    })
  }
}
   

